var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFaceNeutral(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.37769 21.6524C5.12669 20.5006 2 16.6152 2 11.9996C2 6.47696 6.47691 1.99957 12 1.99957C17.5226 1.99957 22 6.47696 22 11.9996C22 16.6617 18.8094 20.5788 14.493 21.6865",
    stroke: "#E48900",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3053 15.0928C15.3053 15.0928 11.8772 15.0926 8.69531 15.0928",
    stroke: "#E48900",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6876 10.6152C16.1758 10.6152 16.5711 10.2201 16.5711 9.7318C16.5711 9.24291 16.1752 8.84742 15.6876 8.84742C15.2001 8.84742 14.8037 9.24334 14.8037 9.7318C14.8037 10.2197 15.1995 10.6152 15.6876 10.6152Z",
    fill: "#E48900",
    stroke: "#E48900",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.31164 10.6152C8.79977 10.6152 9.19508 10.2201 9.19508 9.7318C9.19508 9.24291 8.79921 8.84742 8.31164 8.84742C7.82413 8.84742 7.42773 9.24334 7.42773 9.7318C7.42773 10.2197 7.82356 10.6152 8.31164 10.6152Z",
    fill: "#E48900",
    stroke: "#E48900",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaceNeutral);
export default __webpack_public_path__ + "static/media/face-neutral.85f937ef07a385fb2f2091f55eacbb03.svg";
export { ForwardRef as ReactComponent };